export default {
  navigationBarTitleText: intl.get('selectMember.title'),

};
